<template>
  <div class="row myrow content-mb-42" v-if="$parent.$parent.rerender">
    <div
      class="col-xs-12 mycol"
      v-bind:class="{
        'has-error': $parent.$parent.checkErrorField(
          'PROJECTS',
          'LOGIC',
          'UF_INDUSTRY_ID'
        )
      }"
    >
      <select
        v-model="$parent.project.UF_INDUSTRY_ID"
        class="sel-dropdown i-main-style i-wid-29"
        :disabled="is_disabled || $parent.$parent.projectDisabled"
        v-on:change="
          $parent.$parent.removeError('PROJECTS', 'LOGIC', 'UF_INDUSTRY_ID')
        "
      >
        <option value></option>
        <option
          v-for="item in $parent.directory.tree_industry"
          v-bind:value="item.ID"
          v-bind:key="item.ID"
          v-if="isAllowed(item) && isNotHideItem(item)"
          v-text="item.NAME"
        ></option>
      </select>
      <div class="error-text">
        {{
          $parent.$parent.checkErrorText("PROJECTS", "LOGIC", "UF_INDUSTRY_ID")
        }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "uf_industry_id",
  props: {
    is_disabled: false
  },
  methods: {
    isAllowed(item) {
      //76869 фильтрация через программы доп фильтрация для лизина
      if (
        this.$parent.$parent.getProgramCode(
          this.$parent.project.UF_SUPPORT_PROG_ID
        ) == "lizing"
      ) {
        if (
          this.$parent.project.UF_LIZING_PURCHASED_EQUIPMENT_ID &&
          this.$parent.project.UF_LIZING_PURCHASED_EQUIPMENT_ID > 0
        ) {
          let typeEqupment = this.$parent.directory.sp_purchased_equipment_lizing.filter(
            c => c.ID === this.$parent.project.UF_LIZING_PURCHASED_EQUIPMENT_ID
          );

          if (
            typeEqupment[0].CODE == "specialized_manufacturing_industries" &&
            item.UF_RAZDEL_TYPE === "type_c"
          ) {
            return true;
          } else if (
            typeEqupment[0].CODE == "specialized_manufacturing_industries"
          ) {
            return false;
          }
        }
      }

      //76869 фильтрация через программы
      if (
        Array.isArray(item.UF_SUPPORT_PROGRAM_ID) &&
        !item.UF_SUPPORT_PROGRAM_ID.includes(
          this.$parent.project.UF_SUPPORT_PROG_ID
        )
      ) {
        return false;
      }

      return true;
    },
    isNotHideItem(item) {
      let isFind = false;
      if (this.$parent.project.UF_SETTING.HIDE_INDUSTRIAL_ID) {
        this.$parent.project.UF_SETTING.HIDE_INDUSTRIAL_ID.forEach(function(
          it
        ) {
          if (it == item.ID) {
            isFind = true;
          }
        },
        this);
      }
      return isFind ? false : true;
    }
  }
};
</script>

<style scoped></style>
